import React, { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';
import { useProShellFilterRailMount } from '../../contexts/ProShellFilterRailContext';

/**
 * True when this subtree is rendered inside the MMEC Pro shell right filter rail (portaled).
 * Used by StandardFilterBar and custom tool panels for unified rail typography.
 */
const FilterRailSurfaceContext = createContext(false);

export function useFilterRailSlotSurface(): boolean {
  return useContext(FilterRailSurfaceContext);
}

/** Mark portaled custom panels (non–StandardFilterBar) as using the filter rail surface styles. */
export function FilterRailSurface({ children }: { children: React.ReactNode }) {
  return <FilterRailSurfaceContext.Provider value={true}>{children}</FilterRailSurfaceContext.Provider>;
}

/** When MMEC Pro shell exposes a filter rail mount, render children into it; otherwise inline. */
export function ProToolFilterSlot({ children }: { children: React.ReactNode }) {
  const m = useProShellFilterRailMount();
  if (m) {
    return createPortal(
      <FilterRailSurfaceContext.Provider value={true}>
        <div style={{ width: '100%', boxSizing: 'border-box' }}>{children}</div>
      </FilterRailSurfaceContext.Provider>,
      m
    );
  }
  return (
    <FilterRailSurfaceContext.Provider value={false}>
      {children}
    </FilterRailSurfaceContext.Provider>
  );
}
